<template>
  <div class="container">
    <div class="box" @click="refrash()">
      <img :src="$store.getters.getUrl('yc_header_img1')" alt="" />
      <p>线路中心</p>
    </div>
    <img :src="$store.getters.getUrl('yc_header_logo')" :style="{'width':$store.getters.getKey('width')&&$store.getters.getKey('width'),'height':$store.getters.getKey('height')&&$store.getters.getKey('height')}" alt="" class="logo" />
    <div class="box" @click="openPop()">
      <img :src="$store.getters.getUrl('yc_header_img2')" alt="" />
      <p>信任教程</p>
    </div>
    <transition name="fade">
      <TrustTeachPop v-if="TrustTeachPopShow" @closePop='closePop' :imgUrl="teach"></TrustTeachPop>
    </transition>
  </div>
</template>


<script>
import TrustTeachPop from "../../../components/trustTeachPop.vue"
export default {
  data() {
    return {
      TrustTeachPopShow: false
    };
  },
  components: {
    TrustTeachPop
  },
  computed: {
    teach() {
      return (
        this.$store.getters.getUrl("yc_teach")
      );
    },
  },
  methods: {
    refrash() {
      window.location.reload()
    },
    closePop(closePop) {
      this.TrustTeachPopShow = closePop;
      document.body.removeAttribute('style')
    },
    openPop() {
      this.TrustTeachPopShow = true
      document.querySelector('body').setAttribute('style', 'overflow:hidden;')
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 91px;
  background: #5587ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  p {
    font-size: 26px;
    color: #fff;
    text-decoration: none;
    margin-left: 8px;
  }
  .logo {
    width: 182px;
  }
  .box {
    display: flex;
    align-items: center;
    line-height: 35px;
    cursor: pointer;
    img {
      width: 35px;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s
  }
  .fade-enter, .fade-leave-to  {
      opacity: 0
  }
}
</style>